import {
  EXERCISE_KEY,
  EXERCISE_MECHANICS,
  EXERCISE_TYPE_MESSAGE,
  getMusclesExerciseUtil,
  getTypeExerciseUtil,
  MUSCLE_MESSAGE
} from '@gymaholic/packages'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import { defineMessages } from 'react-intl'
import getValueReduxUtil from 'modules/redux/utils/get-value/index.js'

const messages = defineMessages({
  muscles: {
    id: 'Exercise.muscles',
    defaultMessage: 'The {exerciseName} is {article} {exerciseMechanicsStr} exercise that primary targets your {primaryMusclesStr}.'
  }
})

/**
 * @param props
 * @param props.exercise
 * @param props.intl
 */
function getMusclesWorkedStrByIdExerciseSelectorUtil (props) {
  const {
    intl,
    exercise
  } = props
  const exerciseName = getValueReduxUtil(exercise, EXERCISE_KEY.NAME)
  const type = getTypeExerciseUtil(exercise)
  const exerciseType = formatMessageIntlUtil(intl, EXERCISE_TYPE_MESSAGE[type]).toLowerCase()
  const exerciseMechanics = getValueReduxUtil(exercise, EXERCISE_KEY.MECHANICS)
  let exerciseMechanicsStr
  let article
  if (exerciseMechanics === EXERCISE_MECHANICS.ISOLATION) {
    exerciseMechanicsStr = 'isolation'
    article = 'an'
  } else {
    exerciseMechanicsStr = 'compound'
    article = 'a'
  }

  const muscles = getMusclesExerciseUtil(exercise)
  let primaryMusclesStr = ''
  if (muscles) {
    muscles.map((muscle, index) => {
      if (muscles.length === 1 || muscles.length - 1 === index) {
        primaryMusclesStr += formatMessageIntlUtil(intl, MUSCLE_MESSAGE[muscle]).toLowerCase()
      } else {
        primaryMusclesStr += formatMessageIntlUtil(intl, MUSCLE_MESSAGE[muscle]).toLowerCase()
      }
      return null
    })
  }

  return (
    formatMessageIntlUtil(
      intl,
      messages.muscles,
      {
        exerciseName,
        exerciseMechanicsStr,
        primaryMusclesStr,
        exerciseType,
        article
      }
    )
  )
}

export default getMusclesWorkedStrByIdExerciseSelectorUtil
